/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/bookings/:bookingId/messages",
    },
    (router) => {
      router.push({
        id: "@api/booking.messages@search",
        path: "",
      });
      router.push({
        id: "@api/booking.messages@create",
        path: "",
      });
      router.group(
        {
          path: "/:bookingMessageId",
        },
        (router) => {
          router.push({
            id: "@api/booking.messages.message@show",
            path: "",
          });
          router.push({
            id: "@api/booking.messages.message@update",
            path: "",
          });
          router.push({
            id: "@api/booking.messages.message@delete",
            path: "",
          });
          router.group(
            {
              path: "/attachments/:bookingMessageAttachmentId",
            },
            (router) => {
              router.push({
                id: "@api/booking.messages.message.attachment@delete",
                path: "",
              });
              router.group(
                {
                  path: "/action",
                },
                (router) => {
                  router.push({
                    id: "@api/booking.messages.message.attachment@download",
                    path: "/download",
                  });
                },
              );
            },
          );
        },
      );
    },
  );
}
